type PropsType = {
  locale: string;
  currentPlug: string;
  additionalSlug: string;
  slug: string;
};

export const returnUntranslatedHref = ({
  locale,
  currentPlug,
  additionalSlug,
  slug,
}: PropsType) => {
  return `/${locale ? `${locale}/` : ''}${currentPlug}${additionalSlug}/${slug}`;
};
